import {
  AfterViewInit,
  ContentChildren,
  Directive,
  EventEmitter,
  Input,
  Output,
  QueryList
} from "@angular/core";
import {TableSorter} from "../../tools/table-sorter/table-sorter";
import {TableSorterHeaderDirective} from "./table-sorter-header.directive";

@Directive({
  selector: '[tableSorter]',
  standalone: true
})
export class TableSorterDirective implements AfterViewInit {
  @Input() tableSorter: TableSorter | null = null;
  @Output() tableSorterChange = new EventEmitter<void>();
  @ContentChildren(TableSorterHeaderDirective) headers!: QueryList<TableSorterHeaderDirective>;

  ngAfterViewInit(): void {
    this.headers.forEach((header: TableSorterHeaderDirective) => {
      if (this.tableSorter) {
        header.setTableSorter(this);
      }
    });

    this.updateHeader();
  }

  updateHeader(): void {
    this.headers.forEach((header: TableSorterHeaderDirective) => {
      if (this.tableSorter) {
        header.setSort(this.tableSorter.sortName, this.tableSorter.sortOrder);
      }
    });
  }

  onChange(sortName: string, sortOrder: string): void {
    if (this.tableSorter) {
      this.tableSorter.sortName = sortName;
      this.tableSorter.sortOrder = sortOrder;
    }

    this.updateHeader();

    this.tableSorterChange.emit();
  }
}
